import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { Design } from '../../interfaces/design';
import * as DesignActions from './design.actions';

export const designFeatureKey = 'design';

export interface State extends EntityState<Design> {
  design: Design;
  loading: boolean;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
  error: any;
}

export const adapter: EntityAdapter<Design> = createEntityAdapter<Design>();

export const initialState: State = adapter.getInitialState({
  design: null,
  loading: false,
  creating: false,
  updating: false,
  deleting: false,
  error: null,
});

export const designReducer = createReducer(
  initialState,
  on(DesignActions.loadDesign, (state) => ({ ...state, loading: true })),
  on(DesignActions.loadDesignSuccess, (state, action) => ({ ...state, design: action.design, loading: false })),
  on(DesignActions.loadDesignFailure, (state, action) => ({ ...state, error: action.error, loading: false })),
  on(DesignActions.updateDesign, (state, action) => ({ action, ...state, updating: true })),
  on(DesignActions.updateDesignSuccess, (state, action) => ({ ...state, design: action.design, update: false })),
  on(DesignActions.updateDesignFailure, (state, action) => ({ ...state, error: action.error, updating: false })),
  on(DesignActions.clearDesign, (state) => adapter.removeAll(state))
);

export const selectDesignState = createFeatureSelector<State>(designFeatureKey);
export const selectDesign = createSelector(selectDesignState, (state) => state.design);
export const selectDesignLoading = createSelector(selectDesignState, (state) => state.loading);
